import { j as l } from "./react-944c88e2.js";
import { Icon as C } from "@chakra-ui/icons";
const c = (i) => {
  var e;
  return /* @__PURE__ */ l.jsx(C, { xmlns: "http://www.w3.org/2000/svg", width: "24px", height: "24px", fill: "none", ...i, children: /* @__PURE__ */ l.jsx(
    "path",
    {
      fill: ((e = i == null ? void 0 : i.fill) == null ? void 0 : e.toString()) ?? "#fff",
      fillRule: "evenodd",
      d: "M19.23 19.614A10.47 10.47 0 0 0 22.5 12c0-5.799-4.701-10.5-10.5-10.5S1.5 6.201 1.5 12c0 2.81 1.104 5.363 2.903 7.248 1.63-2.391 4.28-3.967 7.294-3.967 3.167 0 5.93 1.738 7.533 4.333Zm-1.172.963c-1.34-2.298-3.7-3.796-6.36-3.796-2.54 0-4.805 1.365-6.172 3.486A10.455 10.455 0 0 0 12 22.5c2.256 0 4.347-.712 6.058-1.923Zm-13.666.704A11.95 11.95 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12c0 3.445 1.452 6.552 3.778 8.74a.748.748 0 0 0 .614.54Zm9.523-8.906c.603-.694 1.06-1.814 1.06-3.424 0-2.166-1.584-3.7-3.278-3.7s-3.279 1.534-3.279 3.7c0 3 1.644 4.478 3.126 4.478.966 0 1.78-.372 2.371-1.054Zm-2.371 2.554c2.768 0 4.932-2.195 4.932-5.978 0-2.872-2.14-5.2-4.78-5.2-2.638 0-4.778 2.328-4.778 5.2 0 3.456 1.986 5.978 4.626 5.978Z",
      clipRule: "evenodd"
    }
  ) });
}, d = (i) => /* @__PURE__ */ l.jsxs(
  C,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    marginTop: "4px",
    marginRight: "20px",
    viewBox: "0 0 24 24",
    fill: "none",
    children: [
      /* @__PURE__ */ l.jsxs("g", { "clip-path": "url(#clip0_8852_222772)", children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M5 12H9V14H5C2.243 14 0 11.757 0 9C0 6.243 2.243 4 5 4C5.533 4 6.059 4.086 6.562 4.254C7.643 1.699 10.142 0 13 0C16.859 0 20 3.141 20 7C20 8.487 19.53 9.865 18.737 11H15.969C17.194 10.088 18 8.642 18 7C18 4.243 15.757 2 13 2C10.664 2 8.662 3.591 8.135 5.867C8.06 6.184 7.838 6.445 7.536 6.568C7.234 6.689 6.892 6.659 6.619 6.482C6.129 6.167 5.568 6 5 6C3.346 6 2 7.346 2 9C2 10.654 3.346 12 5 12Z",
            fill: "black"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M12 24H23C23.553 24 24 23.553 24 23V16C24 15.447 23.553 15 23 15H17.414L15.707 13.293C15.52 13.105 15.266 13 15 13H12C11.447 13 11 13.447 11 14V23C11 23.553 11.447 24 12 24ZM22 22H13V15H14.586L16.293 16.707C16.48 16.895 16.734 17 17 17H22V22Z",
            fill: "black"
          }
        )
      ] }),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "clip0_8852_222772", children: /* @__PURE__ */ l.jsx("rect", { width: "24", height: "24", fill: "white" }) }) })
    ]
  }
), h = (i) => /* @__PURE__ */ l.jsxs(C, { xmlns: "http://www.w3.org/2000/svg", width: "24px", height: "24px", fill: "none", ...i, children: [
  /* @__PURE__ */ l.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 6.09V7.909H20.506C20.425 8.221 20.303 8.513 20.148 8.786L21.089 9.728L19.726 11.091L18.784 10.151C18.511 10.306 18.22 10.427 17.907 10.509V12H16.09V10.508C15.778 10.427 15.486 10.305 15.214 10.15L14.272 11.09L12.908 9.727L13.85 8.785C13.695 8.512 13.573 8.22 13.491 7.908H12V6.09H13.492C13.574 5.778 13.696 5.486 13.851 5.214L12.909 4.272L14.273 2.909L15.215 3.85C15.487 3.694 15.779 3.573 16.091 3.492V2H17.908V3.492C18.221 3.573 18.513 3.694 18.785 3.85L19.728 2.909L21.091 4.272L20.15 5.214C20.305 5.486 20.427 5.778 20.508 6.09H22ZM15 7C15 8.104 15.895 9 17 9C18.105 9 19 8.104 19 7C19 5.896 18.105 5 17 5C15.895 5 15 5.896 15 7Z",
      fill: "black"
    }
  ),
  /* @__PURE__ */ l.jsx(
    "path",
    {
      d: "M17.65 14.0002H19.726C19.492 14.8992 19.124 15.7452 18.614 16.4932L20.132 18.0112L18.011 20.1332L16.493 18.6152C15.744 19.1252 14.901 19.5042 14 19.7372V22.0002H10V19.7372C9.099 19.5032 8.256 19.1252 7.507 18.6152L5.989 20.1332L3.868 18.0112L5.386 16.4932C4.875 15.7442 4.496 14.9032 4.264 14.0002H2V10.0002H4.264C4.496 9.09816 4.875 8.25616 5.386 7.50716L3.868 5.98916L5.989 3.86816L7.507 5.38516C8.255 4.87516 9.101 4.50816 10 4.27416V6.35016C7.674 7.17716 6 9.39416 6 12.0002C6 15.3102 8.691 18.0002 12 18.0002C14.606 18.0002 16.824 16.3282 17.65 14.0002Z",
      fill: "black"
    }
  )
] }), o = (i) => /* @__PURE__ */ l.jsxs(
  C,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    fill: "none",
    marginTop: "4px",
    marginRight: "20px",
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          d: "M13.5 16.5C13.5 17.3284 12.8284 18 12 18C11.1716 18 10.5 17.3284 10.5 16.5C10.5 15.6716 11.1716 15 12 15C12.8284 15 13.5 15.6716 13.5 16.5Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M9 11H17C18.103 11 19 11.897 19 13V20C19 21.103 18.103 22 17 22H7C5.897 22 5 21.103 5 20V13C5 11.898 5.897 11 7 11V8C7 5.243 9.243 3 12 3C14.757 3 17 5.243 17 8V9H15V8C15 6.346 13.654 5 12 5C10.346 5 9 6.346 9 8V11ZM7 13V20H17.001L17 13H7Z",
          fill: "black"
        }
      )
    ]
  }
);
export {
  d as C,
  o as L,
  c as P,
  h as a
};
